import { render, staticRenderFns } from "./PasswordSet.vue?vue&type=template&id=5aefd726&scoped=true"
import script from "./PasswordSet.vue?vue&type=script&lang=js"
export * from "./PasswordSet.vue?vue&type=script&lang=js"
import style0 from "./PasswordSet.vue?vue&type=style&index=0&id=5aefd726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aefd726",
  null
  
)

export default component.exports